import useSWRMutation from 'swr/mutation';

import { fetcher } from '@/data/fetcher';
import { useOrganizationId } from '@/hooks/useSwr';
import { GetFeedbackQueryParams } from '@/types/schema';
import { FeedbackSchema } from '@/types/schema';
import { apiFeedbackPath } from '@/utils/constants';

export function useFeedbackSourceRunIds(
  feedbackKey: string,
  runIds?: string[],
  comparativeExperimentId?: string | null,
  options?: {
    onSuccess?: (data: FeedbackSchema[]) => void;
  }
) {
  const organizationId = useOrganizationId();

  const fetchFeedback = useSWRMutation(
    {
      type: 'feedback-open-source',
      runIds,
    },
    async (values) => {
      const feedbacks = await fetcher<FeedbackSchema[], GetFeedbackQueryParams>(
        {
          url: apiFeedbackPath,
          params: { run: values.runIds },
          headers: { 'X-Tenant-Id': organizationId },
        }
      );

      const feedbacksForKey = feedbacks
        .filter((i) => i.key === feedbackKey)
        .filter(
          (i) =>
            i.comparative_experiment_id === comparativeExperimentId ||
            !comparativeExperimentId ||
            !i.comparative_experiment_id
        )
        .filter(Boolean);

      if (options?.onSuccess) {
        options.onSuccess(feedbacksForKey);
      }

      return feedbacksForKey;
    }
  );

  return fetchFeedback;
}
